import { useEffect } from "react";
import {
  TEMPLATE_REGISTRY,
  TemplateDefinition,
} from "@/components/AIComponents/ExportablesModal/templates/registry";
import ExportablesTemplateGallery from "@/components/AIComponents/ExportablesModal/ExportablesEditor/ExportablesTemplateGallery/ExportablesTemplateGallery";
import { ExportablesGenerationResponse } from "@/types/models/Exportables.interface";
import { MainIdeaFormData } from "@/components/AIComponents/ExportablesModal/templates/MainIdeaOrganizer";

import ExportableTemplatePreview from "./ExportablesTemplatePreview";
import { containerStyles } from "./ExportablesEditor.style";
// Define exportable item type for consistency
export interface ExportableItem {
  [key: string]: TemplateDefinition<any>;
}

export interface ExportablesEditorProps {
  exportablesMetadata: ExportablesGenerationResponse | undefined;
  setFormData: (data: any) => void;
  formData: MainIdeaFormData | any | null;
  selectedExportable: TemplateDefinition<any> | null;
  setSelectedExportable: (exportable: TemplateDefinition<any> | null) => void;
  articleShortTitle?: string | undefined;
}

function ExportablesEditor({
  exportablesMetadata,
  selectedExportable,
  setSelectedExportable,
  formData,
  setFormData,
  articleShortTitle,
}: ExportablesEditorProps) {
  useEffect(() => {
    setFormData(
      selectedExportable && selectedExportable.seti_identifier
        ? {
            ...exportablesMetadata?.[selectedExportable.seti_identifier],
            articleShortTitle,
          }
        : {},
    );
  }, [JSON.stringify(selectedExportable), JSON.stringify(exportablesMetadata)]);

  return (
    <div css={containerStyles}>
      <ExportablesTemplateGallery
        exportables={TEMPLATE_REGISTRY}
        selectedExportable={selectedExportable}
        setSelectedExportable={setSelectedExportable}
      />
      <ExportableTemplatePreview
        formData={formData}
        selectedExportable={selectedExportable}
        setFormData={setFormData}
      />
    </div>
  );
}

export default ExportablesEditor;
